import { render, staticRenderFns } from "./msgPage.vue?vue&type=template&id=1dfbc14f&scoped=true"
import script from "./msgPage.vue?vue&type=script&lang=js"
export * from "./msgPage.vue?vue&type=script&lang=js"
import style0 from "./msgPage.vue?vue&type=style&index=0&id=1dfbc14f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfbc14f",
  null
  
)

export default component.exports